var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar" }, [
    _c("div", { staticClass: "breadcrumb" }, [
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _c(
            "el-dropdown",
            { staticClass: "avatar-container", attrs: { trigger: "click" } },
            [
              _c(
                "div",
                { staticClass: "avatar-wrapper" },
                [
                  _vm.avatar !== "" &&
                  _vm.avatar != null &&
                  _vm.avatar != undefined
                    ? _c("el-avatar", {
                        staticClass: "avatarM",
                        attrs: { shape: "square", src: _vm.avatar },
                      })
                    : _c("img", {
                        staticClass: "avatarM",
                        attrs: { src: _vm.styleTheme.avatar },
                      }),
                  _c(
                    "span",
                    { staticClass: "spanM", attrs: { id: "spanId" } },
                    [
                      _vm._v(" " + _vm._s(_vm.name) + " "),
                      _c(
                        "div",
                        { staticClass: "spanMDiv" },
                        [
                          _c("el-switch", {
                            attrs: {
                              value: _vm.themeSelect === "1" ? true : false,
                            },
                            nativeOn: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.changeTheme($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "divM", attrs: { id: "divMId" } }, [
                    _c("i", { staticClass: "el-icon-caret-bottom" }),
                  ]),
                ],
                1
              ),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [_c("el-dropdown-item", [_vm._v("回到首页")])],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.signout($event)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v("退出登录"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }